import "./DeletedMessage.scss";
import { useTranslation } from "react-i18next";

export default function DeletedMessage() {
      const { t } = useTranslation();
  return (
    <div className="deleted-message-wrapper">
      <div className="check"></div>
      <div className="message">{t('deleted')}</div>
    </div>
  );
}
